





















































import Vue, { PropType } from "vue";
import { AdminStore } from "@/common/models/AdminStore";
import { StoreWorkstationType } from "@/common/models/StoreWorkstationType";
import { PosConfigurationType } from "@/common/models/PosConfiguration";
import { v4 as uuid } from "uuid";
import { StoreWorkstationInput } from "@/common/models/StoreWorkstation";
import { FieldRules } from "@/common/utils/FieldRules";
import { storeWorkstationService } from "@/common/services/StoreWorkstationService";

export default Vue.extend({
  name: "WorkstationEdit",
  components: {},
  props: {
    store: {
      type: Object as PropType<AdminStore>,
      required: true,
    },
  },
  data() {
    return {
      qrCode: "" as string,
      posId: null as string | null,
      workstationId: null as number | null,
      type: null as StoreWorkstationType | null,
      posConfigurationType: this.store.configuration?.posConfiguration?.type,
      savingWorkstation: false as boolean,
      workstationTypeOptions: [
        {
          name: "Manned",
          type: StoreWorkstationType.MANNED,
        },
        {
          name: "Virtual",
          type: StoreWorkstationType.VIRTUAL,
        },
      ],
      PosConfigurationType,
      ...FieldRules,
    };
  },
  methods: {
    generateQrCode() {
      this.qrCode = uuid().toString();
    },
    isDataValid() {
      return this.qrCode.includes("-") && (this.posId || this.workstationId) && this.type;
    },
    async save() {
      this.savingWorkstation = true;
      const workstation = new StoreWorkstationInput(
        this.qrCode,
        this.store.id,
        this.type!,
        this.posId,
        this.workstationId
      );
      await storeWorkstationService.createWorkstation(workstation);
      this.savingWorkstation = false;
      this.onClose();
    },
    onClose() {
      this.qrCode = "";
      this.posId = null;
      this.type = null;
      this.workstationId = null;
      this.$emit("close");
    },
  },
});
